const langAuthOktaUserActivation = {
	title_activation: {
		tag: 'auth.okta_user_activation.title_activation',
		fr: 'Activation de votre compte',
		en: 'Activate your account',
	},
	field_error_password_required: {
		tag: 'auth.okta_user_activation.field_error_password_required',
		fr: 'Le mot de passe est requis',
		en: 'Password is required',
	},
	field_error_password_too_short: {
		tag: 'auth.okta_user_activation.field_error_password_too_short',
		fr: 'Le mot de passe est trop court',
		en: 'Password is too short',
	},
	field_error_password_must_contain_one_lowercase: {
		tag: 'auth.okta_user_activation.field_error_password_must_contain_one_lowercase',
		fr: 'Le mot de passe doit contenir au moins une minuscule',
		en: 'Password must contain at least one lowercase',
	},
	field_error_password_must_contain_one_uppercase: {
		tag: 'auth.okta_user_activation.field_error_password_must_contain_one_uppercase',
		fr: 'Le mot de passe doit contenir au moins une majuscule',
		en: 'Password must contain at least one uppercase',
	},
	field_error_password_must_contain_one_number: {
		tag: 'auth.okta_user_activation.field_error_password_must_contain_one_number',
		fr: 'Le mot de passe doit contenir au moins un chiffre',
		en: 'Password must contain at least one number',
	},
	field_error_passwords_do_not_match: {
		tag: 'auth.okta_user_activation.field_error_passwords_do_not_match',
		fr: 'Les mots de passe ne correspondent pas',
		en: 'Passwords do not match',
	},
	field_error_password_confirm_required: {
		tag: 'auth.okta_user_activation.field_error_password_confirm_required',
		fr: 'La confirmation du mot de passe est requise',
		en: 'Password confirm is required',
	},
	text_success: {
		tag: 'auth.okta_user_activation.text_success',
		fr: 'Félicitations, votre compte est désormais actif, vous pouvez maintenant vous identifier avec votre e-mail et votre mot de passe.',
		en: 'Congratulations, your account has been successfully created. You can now login using your email and password.',
	},
	btn_login: {
		tag: 'auth.okta_user_activation.btn_login',
		fr: "S'identifier",
		en: 'Sign-in',
	},
	text_hello: {
		tag: 'auth.okta_user_activation.text_hello',
		fr: 'Bonjour {{firstName}} {{lastName}},',
		en: 'Hello {{firstName}} {{lastName}},',
	},
	label_password: {
		tag: 'auth.okta_user_activation.label_password',
		fr: 'Créez un nouveau mot de passe',
		en: 'Create a new password',
	},
	label_password_helpertext: {
		tag: 'auth.okta_user_activation.label_password_helpertext',
		fr: 'Le mot de passe doit contenir au moins 8 caractères, 1 chiffre, 1 lettre majuscule et 1 lettre minuscule',
		en: 'The password must contain at least 8 characters, 1 number, 1 upper case letter and 1 lower case letter',
	},
	label_password_confirmation: {
		tag: 'auth.okta_user_activation.label_password_confirmation',
		fr: 'Confirmez votre nouveau mot de passe',
		en: 'Confirm your new password',
	},
	text_presentation: {
		tag: 'auth.okta_user_activation.text_presentation',
		fr: "Afin de finaliser l'activation de votre compte, veuillez créer un mot de passe.",
		en: 'In order to finalize the activation of your account, please create a password.',
	},
	btn_save: {
		tag: 'auth.okta_user_activation.btn_save',
		fr: 'Activer mon compte',
		en: 'Activate my account',
	},
};

export default langAuthOktaUserActivation;
